import { createSelector } from 'reselect'

const getLesson = (state, props) => state.lessons[props.entityUID]

// TODO: Revisar y asegurarse de que se esta haciendo bien el momorize
const makeCartGotoCheckoutSelector = createSelector(
	[getLesson],
	lesson => ({
		name: lesson.data.name,
	})
)

export default makeCartGotoCheckoutSelector
